import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      light: '#3b82f6',
      main: '#1e3a8a',
      dark: '#1e1b4b',
      contrastText: '#fff',
    },
    secondary: {
      light: '#67e8f9',
      main: '#06b6d4',
      dark: '#0891b2',
      contrastText: '#fff',
    },
    success: {
      main: '#10b981',
      dark: '#059669',
    },
    error: {
      main: '#ef4444',
      dark: '#dc2626',
    },
    warning: {
      main: '#f59e0b',
      dark: '#d97706',
    },
    info: {
      main: '#06b6d4',
      dark: '#0891b2',
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff',
    },
    text: {
      primary: '#1e293b',
      secondary: '#64748b',
    },
  },
  typography: {
    fontFamily: '"Poppins", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      color: '#1e293b',
    },
    h2: {
      fontWeight: 600,
      color: '#1e293b',
    },
    h3: {
      fontWeight: 600,
      color: '#1e293b',
    },
    h4: {
      fontWeight: 600,
      color: '#1e293b',
    },
    h5: {
      fontWeight: 600,
      color: '#1e293b',
    },
    h6: {
      fontWeight: 600,
      color: '#1e293b',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '0.75rem 1.5rem',
          transition: 'all 0.2s ease',
          textTransform: 'none',
          fontWeight: 600,
          '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: '0px 8px 20px rgba(30, 58, 138, 0.15)',
          },
        },
        contained: {
          boxShadow: '0px 4px 12px rgba(30, 58, 138, 0.15)',
          '&.MuiButton-containedPrimary': {
            background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #1e1b4b 0%, #1e3a8a 100%)',
            },
          },
          '&.MuiButton-containedSecondary': {
            background: 'linear-gradient(135deg, #06b6d4 0%, #67e8f9 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #0891b2 0%, #06b6d4 100%)',
            },
          },
        },
        outlined: {
          borderWidth: '2px',
          '&:hover': {
            borderWidth: '2px',
            backgroundColor: 'rgba(30, 58, 138, 0.04)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0px 4px 16px rgba(30, 58, 138, 0.08)',
          borderRadius: 12,
          overflow: 'hidden',
          transition: 'all 0.3s ease',
          border: '1px solid rgba(30, 58, 138, 0.08)',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0px 8px 24px rgba(30, 58, 138, 0.12)',
            borderColor: 'rgba(6, 182, 212, 0.2)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
        elevation1: {
          boxShadow: '0px 2px 8px rgba(30, 58, 138, 0.06)',
        },
        elevation2: {
          boxShadow: '0px 4px 16px rgba(30, 58, 138, 0.08)',
        },
        elevation3: {
          boxShadow: '0px 8px 24px rgba(30, 58, 138, 0.1)',
        },
        elevation4: {
          boxShadow: '0px 12px 32px rgba(30, 58, 138, 0.12)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            transition: 'all 0.2s ease',
            '& fieldset': {
              borderColor: 'rgba(30, 58, 138, 0.2)',
            },
            '&:hover fieldset': {
              borderColor: 'rgba(30, 58, 138, 0.4)',
              boxShadow: '0px 2px 8px rgba(30, 58, 138, 0.08)',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#1e3a8a',
              borderWidth: '2px',
              boxShadow: '0px 4px 12px rgba(30, 58, 138, 0.12)',
            },
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          color: '#1e293b',
          boxShadow: '0px 1px 3px rgba(30, 58, 138, 0.1)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 6,
        },
        filled: {
          backgroundColor: 'rgba(6, 182, 212, 0.1)',
          color: '#0891b2',
          '&.MuiChip-colorPrimary': {
            backgroundColor: 'rgba(30, 58, 138, 0.1)',
            color: '#1e3a8a',
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
});

export default theme;